import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";

// OBTIENE TODA LA INFORMACION DE LOS PRODUCTOS
export const getEstadosPurchase = async () => {
    const respuesta = PrivateInterceptor('status/Purchase', 'GET')
    return respuesta
};

// OBTENER TODOS LOS ESTADOS Security
export const getEstadosSecurity = async () => {
    const respuesta = PrivateInterceptor('status/Security', 'GET')
    return respuesta
}
// OBTENER TODOS LOS ESTADOS Security
export const getEstadosSalidaTelaCruda = async () => {
    const respuesta = PrivateInterceptor('status/SalidaTelaCruda', 'GET')
    return respuesta
}

// OBTENER TODOS LOS ESTADOS Fabrics
export const getEstadosFabrics = async () => {
    const respuesta = PrivateInterceptor('status/Fabrics', 'GET')
    return respuesta
}

// OBTENER TODOS LOS ESTADOS Fabrics
export const getEstadosDispositivos = async () => {
    const respuesta = PrivateInterceptor('status/Dispositivos', 'GET')
    return respuesta
}

// OBTIENE ESTADO DE Cotizaciones
export const getEstadosCotizaciones = async () => {
    const respuesta = PrivateInterceptor('status/Cotizaciones', 'GET')
    return respuesta
};